import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import classNames from 'classnames';
import useScreen from 'hooks/useScreen';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import ImageContentBlock from './components/ImageContentBlock';
import CardCarousel from '../image-slider-standard/components/CardCarousel';
import FixedWidthContainer from '../FixedWidthContainer';
import EmblaCarousel, { EmblaSlide } from '../image-slider-standard/components/EmblaCarousel';
const MOBILE_SCROLL_TEXT = 'Scroll for more >';
const HIDE_SCROLLBAR_CLASSES = 'overflow-x-auto snap-x snap-mandatory [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden';
const DEFAULT_BLOCK_SECTION = {};
const GridView = t0 => {
  const $ = _c(13);
  const {
    blocks,
    size,
    isMobile,
    columns
  } = t0;
  let t1;
  if ($[0] !== columns || $[1] !== isMobile) {
    t1 = isMobile && columns > 2 && <span className={classNames("block w-full text-left text-xs", {
      "ml-2": isNewConsumerApp
    })} aria-live="polite">{MOBILE_SCROLL_TEXT}</span>;
    $[0] = columns;
    $[1] = isMobile;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = size === "Full Width";
  const t3 = size === "Full Page";
  let t4;
  if ($[3] !== isMobile || $[4] !== t2 || $[5] !== t3) {
    t4 = classNames("flex flex-row [&>*]:!mt-0", {
      "w-full": t2,
      "max-w-[1400px]": t3,
      "overflow-x-auto snap-x snap-mandatory": isMobile,
      [HIDE_SCROLLBAR_CLASSES]: isMobile
    });
    $[3] = isMobile;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== blocks || $[8] !== t4) {
    t5 = <div className="w-full flex"><div className={t4}>{blocks}</div></div>;
    $[7] = blocks;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t5) {
    t6 = <>{t1}{t5}</>;
    $[10] = t1;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
const CarouselView = t0 => {
  const $ = _c(2);
  const {
    blocks
  } = t0;
  let t1;
  if ($[0] !== blocks) {
    t1 = <CardCarousel navType="Button" variant="blog-slider" visibleSlides={4} fullHeight={true}>{blocks}</CardCarousel>;
    $[0] = blocks;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const MultipleBlocks = t0 => {
  const $ = _c(28);
  const {
    config
  } = t0;
  const {
    imageComponent: t1,
    blockSectionConfig: t2,
    blockSection: t3
  } = config;
  const {
    size: t4
  } = t1;
  const size = t4 === undefined ? "Full Width" : t4;
  const {
    columns: t5
  } = t2;
  const columns = t5 === undefined ? 2 : t5;
  const blockSection = t3 === undefined ? DEFAULT_BLOCK_SECTION : t3;
  const {
    isMobile
  } = useScreen();
  let t6;
  if ($[0] !== blockSection) {
    t6 = Object.values(blockSection);
    $[0] = blockSection;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== columns || $[3] !== t6) {
    t7 = t6.slice(0, columns).filter(Boolean);
    $[2] = columns;
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const blocksArray = t7;
  const canScroll = !isMobile && columns > 4 || isMobile && columns > 2;
  const hasGaps = !isMobile && columns > 3;
  let t8;
  if ($[5] !== blocksArray || $[6] !== columns || $[7] !== hasGaps || $[8] !== isMobile) {
    t8 = blocksArray.map((blockConfig, index) => isNewConsumerApp ? <EmblaSlide className={classNames("basis-1/2", {
      "!basis-1/3": !isMobile && columns === 3,
      "!basis-1/4": !isMobile && columns >= 4,
      "!pl-0": !hasGaps
    })} key={`blockSection-${blockConfig?.title?.text}-${blockConfig?.body?.text}-${index + 1}`}><ImageContentBlock blockConfig={blockConfig} /></EmblaSlide> : <div className={classNames("min-w-[50%] md:min-w-[25%]", {
      "px-2": isNewConsumerApp
    })} key={`blockSection-${blockConfig?.title?.text}-${blockConfig?.body?.text}-${index + 1}`}><ImageContentBlock blockConfig={blockConfig} /></div>);
    $[5] = blocksArray;
    $[6] = columns;
    $[7] = hasGaps;
    $[8] = isMobile;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const blocks = t8;
  const showCarousel = columns >= 4 && !isMobile;
  const t9 = size === "Full Width";
  const t10 = size === "Full Page";
  let t11;
  if ($[10] !== t10 || $[11] !== t9) {
    t11 = classNames({
      "w-full max-w-none": t9,
      "max-w-[1400px]": t10
    });
    $[10] = t10;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== blocks || $[14] !== columns || $[15] !== isMobile || $[16] !== showCarousel || $[17] !== size) {
    t12 = !isNewConsumerApp && (showCarousel ? <CarouselView blocks={blocks} /> : <GridView blocks={blocks} size={size} isMobile={isMobile} columns={columns} />);
    $[13] = blocks;
    $[14] = columns;
    $[15] = isMobile;
    $[16] = showCarousel;
    $[17] = size;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== blocks || $[20] !== canScroll || $[21] !== columns || $[22] !== hasGaps) {
    t13 = isNewConsumerApp && <EmblaCarousel className={classNames({
      "pointer-events-none": !canScroll,
      "[&_.embla-container]:!-ml-0": !hasGaps
    })} variant="blog-slider" forceHideButtons={columns < 5}>{blocks}</EmblaCarousel>;
    $[19] = blocks;
    $[20] = canScroll;
    $[21] = columns;
    $[22] = hasGaps;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t11 || $[25] !== t12 || $[26] !== t13) {
    t14 = <FixedWidthContainer className={t11}>{t12}{t13}</FixedWidthContainer>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
};
export default MultipleBlocks;